export const colorSubpallet = '#E4FFD2DD';
export const colorSubpalletHover = '#C6FAA3DD';
